import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import deepForceUpdate from 'react-deep-force-update';
import { ApplyLocale as InstUiApplyLocale } from '@instructure/ui-i18n';
import setupFormatMessage from '../util/setupFormatMessage';

/**
 * A component for configuring i18n for quizzes-ui components.
 *
 * Note: This component internally uses inst-ui's ApplyLocale component as well.
 */
export var ApplyLocale = /*#__PURE__*/function (_PureComponent) {
  function ApplyLocale(props) {
    var _this2;
    _classCallCheck(this, ApplyLocale);
    _this2 = _callSuper(this, ApplyLocale, [props]);
    _this2.configureFormatMessage();
    return _this2;
  }
  _inherits(ApplyLocale, _PureComponent);
  return _createClass(ApplyLocale, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.locale !== prevProps.locale || this.props.translations !== prevProps.translations) {
        this.configureFormatMessage();
        console.warn('Dynamically changing locale or translations may lead to performance issues, proceed with caution.');
        // TODO: Make our format-message usage respond to locale/timezone changes so we don't need to deepForceUpdate
        // Updating the format-message setup doesn't trigger a render, so we have to do it manually.
        deepForceUpdate(this);
      }
    }
  }, {
    key: "configureFormatMessage",
    value: function configureFormatMessage() {
      var _this$props = this.props,
        locale = _this$props.locale,
        translations = _this$props.translations,
        logMissingTranslations = _this$props.logMissingTranslations;
      setupFormatMessage(locale, {
        translations: translations,
        logMissingTranslations: logMissingTranslations
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        locale = _this$props2.locale,
        timezone = _this$props2.timezone,
        children = _this$props2.children;
      return /*#__PURE__*/React.createElement(InstUiApplyLocale, {
        locale: locale,
        timezone: timezone
      }, typeof children === 'function' ? children() : children);
    }
  }]);
}(PureComponent);
_defineProperty(ApplyLocale, "propTypes", {
  /**
   * The locale to use for numbers and dates
   */
  locale: PropTypes.string,
  /**
   * The translated strings to use for the provided locale. Pre-configured translations for many locales are provided
   * in the @instructure/quiz-translations package.
   */
  translations: PropTypes.objectOf(PropTypes.shape({
    message: PropTypes.string
  })),
  /**
   * A Component or a function that returns a Component. The latter is necessary when a translated string is this
   * component's immediate child, i.e. <ApplyLocale>{t('Hello World')}</ApplyLocale>
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.func]).isRequired,
  /**
   * Controls whether missing translations are logged to the console or not
   */
  logMissingTranslations: PropTypes.bool,
  /**
   A timezone identifier in the format: Area/Location
   **/
  timezone: PropTypes.string
});
_defineProperty(ApplyLocale, "defaultProps", {
  locale: 'en',
  translations: null,
  logMissingTranslations: false,
  timezone: null
});
export default ApplyLocale;